import { AppPermission, LoginPermissionKey } from '@insight2profit/drive-app';

type PermissionKey = LoginPermissionKey;

export const PERMISSIONS: Record<PermissionKey, AppPermission<PermissionKey>> = {
    login: 'bwg-jjh.login',
};
